@if (images$ | async; as images) {
  <div class="smartphoto-pictures-gallery">
    <swiper-container
      appSwiper
      class="smartphoto-pictures-gallery__swiper"
      #swiper
      zoom="true"
      effect="coverflow"
      [config]="{
        coverflowEffect: {
          rotate: 30,
          slideShadows: false
        },
        pagination: true
      }"
    >
      @for (item of images; track item.uuid) {
        <swiper-slide class="smartphoto-pictures-gallery__slide">
          <div class="swiper-zoom-container">
            <img class="smartphoto-pictures-gallery__image" [src]="item.url" alt="{{ item.caption }}" />
          </div>
        </swiper-slide>
      }
    </swiper-container>
  </div>

  <bdeo-button
    [disabled]="loadingDownload"
    class="smartphoto-pictures-gallery__download"
    size="medium"
    (click)="downloadImage()"
    skin="outline"
    type="secondary"
    icon="arrow-download-outline"
    iconposition="left"
    htmltype="button"
  ></bdeo-button>

  <bdeo-icon class="smartphoto-pictures-gallery__back" (click)="onClose()" color="var(--default)" name="arrow-left"></bdeo-icon>
}
